import React, { useContext, useMemo } from 'react';

import Inputs from 'components/Inputs';
import CurrentUserContext from 'contexts/CurrentUserContext';
import getIdentifier from 'getIdentifier';
import getTimeStamp from 'getTimeStamp';
import FormInput from 'kingpin/forms/FormInput';

import ShadowedList from '../../../../ShadowedList';
import useSaveWidget from '../../../hooks/useSaveWidget';
import WidgetFooter from '../../WidgetFooter';
import { useBonusConfigOptions } from '../BonusTotalRewardWizard';
import { WidgetWrapper } from '../MetricSlideoutWizard/styles';

// Only programs whose bonus config enables recognition payments.
const isRecognitionPaymentsProgram = (program: BonusTypes.BonusProgram) =>
  !!program.additionalPayments;

const RecognitionPaymentsWizard = ({
  close,
  editingSection,
  lockedBonusConfigId,
}: {
  close: () => void;
  editingSection?: PerformanceBoardTypes.SlideOut.RecognitionPaymentsSection;
  lockedBonusConfigId?: string;
}) => {
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { bonusConfigId, bonusConfigOptions } = useBonusConfigOptions({
    editingSection,
    lockedBonusConfigId,
    isProgramOffered: isRecognitionPaymentsProgram,
  });

  const draftSection = useMemo(():
    | PerformanceBoardTypes.SlideOut.RecognitionPaymentsSection
    | undefined => {
    if (!bonusConfigId) {
      return undefined;
    }
    return {
      id: editingSection ? editingSection.id : getIdentifier(),
      sectionType: 'Additional Payments',
      title: 'Additional Payments',
      bonusConfigId,
      createdOn: editingSection ? editingSection.createdOn : getTimeStamp(),
      createdBy: editingSection ? editingSection.createdBy : currentUserId,
      updatedBy: currentUserId,
      updatedOn: getTimeStamp(),
    };
  }, [bonusConfigId, currentUserId, editingSection]);

  const saveWidget = useSaveWidget({
    section: draftSection,
    editingSection,
  });

  return (
    <>
      <ShadowedList>
        <WidgetWrapper>
          <FormInput label={'Bonus Program'}>
            <Inputs.Dropdown
              options={bonusConfigOptions}
              testId={'recognition-payments-program'}
            />
          </FormInput>
        </WidgetWrapper>
      </ShadowedList>

      <WidgetFooter
        saveWidget={saveWidget}
        sectionType="Additional Payments"
        isDisabled={draftSection === undefined}
        close={close}
      />
    </>
  );
};

export default RecognitionPaymentsWizard;
